export default __webpack_public_path__ + "17bb68f5723ad3df8d6fa0927bb8a8a4.png";